module.exports = __webpack_public_path__ + "static/media/logo-lotflo.884ffb9c.svg";